<h3 mat-dialog-title>Grille de salaire - {{ data.jobType.name }}</h3>
<mat-dialog-content>
  <app-salary-scale-form
    [initWith]="salaryScale"
    [editable]="data.editSalaryScale === undefined"
  ></app-salary-scale-form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="onCancel()">Annuler</button>
  <app-save-button
    (click)="onSave()"
    [isEditMode]="!!data.editSalaryScale"
    [enabled]="!!(salaryScaleForm && salaryScaleForm.formGroup.valid)"
  ></app-save-button>
</mat-dialog-actions>
